// extracted by mini-css-extract-plugin
export default {"react-code-input":"styles_react-code-input__yWU2H","selectWrapper":"styles_selectWrapper__Du7ij"};